const collapseContextKey = /* @__PURE__ */ Symbol("collapseContextKey");

export { collapseContextKey };
//# sourceMappingURL=constants.mjs.map
